export default __webpack_public_path__ + "static/media/Animale_desktop_banner_2.16267d3e.png";